<template>
    <div class="wrapper clearfix">
        <AppUpdateBanner />
        <Loader v-if="loading" />
        <template v-else>
            <Onboarding />
            <app-view />
        </template>
        <ConfirmDialogHost />
        <ToastContainer />
    </div>
</template>

<script>
    import Loader from '@/components/Loader'
    import Onboarding from '@/components/Onboarding'
    import ConfirmDialogHost from '@/shared/confirm/ConfirmDialogHost'
    import ToastContainer from '@/shared/toast/ToastContainer'
    import AppUpdateBanner from '@/shared/app-update/AppUpdateBanner'
    import LiveCaller from '@/LiveCaller'
    import { useAuthStore } from '@/stores/auth'

    export default {
        components: {
            Loader,
            Onboarding,
            ConfirmDialogHost,
            ToastContainer,
            AppUpdateBanner,
        },
        data() {
            return {
                loading: true,
            }
        },
        mounted() {
            if (this.$storage.has('oauth_state')) {
                this.loading = false
                return
            }

            // Skip API calls if we're on OAuth callback page - token hasn't been exchanged yet
            if (window.location.pathname.includes('/oauth/callback')) {
                this.loading = false
                return
            }

            // Skip auth check for guest routes (signin, signup, forgot-password, reset-password)
            const guestRoutes = ['/signin', '/signup', '/forgot-password']
            const isGuestRoute = guestRoutes.includes(window.location.pathname) ||
                window.location.pathname.startsWith('/reset-password/')
            if (isGuestRoute) {
                this.loading = false
                return
            }

            useAuthStore().load(false)
                .then(() => {
                })
                .catch((e) => {
                    try {
                        if (e.response.status === 401) {
                            this.$router.push('/signin').catch(() => {})
                        } else if (e.response.status === 403) {
                            LiveCaller.app.$_error('Error403', { description: e.response?.data?.message })
                        } else {
                            LiveCaller.app.$_error('Error500')
                        }
                    } catch (error) {
                        LiveCaller.app.$_error('Error500', error)
                    }
                })
                .finally(() => {
                    this.loading = false
                })
            useAuthStore().isWhiteListedIp()
        },
    }
</script>

<style lang="css" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .7s .4s ease;
    }

    .fade-enter-from, .fade-leave-to {
        transition: opacity .7s ease;
        opacity: 0;
    }
</style>
